<template>
  <div :class="{
    'row': !full
  }">
    <div :class="{
      [ $ALERT_COL ]: !full
    }">
      <Alert class="alert-attention" title="Your store is password protected &rarr;" icon="IconImportant" titleLink="reports_health"></Alert>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    full: Boolean
  }
}
</script>
